import React, { useEffect, useCallback, useState } from 'react';
import { useDebounce } from 'use-debounce';
import Container from './Search.styl';
import getSearch from '@src/Data/DataSource/Search';
import {SearchResult, GetSearchResponse} from '@Data/Model/Search';
import Hls from 'hls.js';

function castTime(time: number) {
  const date = new Date(0);
  date.setSeconds(time);
  return date.toISOString().substring(11, 19)
}

export type VideoProps = {
  hls?: Hls;
  primaryColor?: string;
  textColor?: string;
  authorization?: string;
  mediaCode?: string;
  onClose: () => void;
  opened?: boolean;
  hasAIOpened?: boolean;
};
// eslint-disable-next-line import/no-anonymous-default-export
export default ({
  hls,
  authorization,
  mediaCode,
  onClose,
  opened = false,
  primaryColor,
  textColor,
  hasAIOpened,
}: VideoProps) => {
  const [results, setResults] = useState<SearchResult[]>([]);
  const [search, setSearch] = useState<string>('');
  const [searchValue] = useDebounce(search, 300);

  const onSearchClose = useCallback(() => {
    setSearch('');
    onClose();
  }, []);

  const onSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;

    setSearch(value);

    if (!value || value.toString().length < 2) {
      return;
    }
  };

  useEffect(() => {
    if (!searchValue || searchValue.length < 2) {
      return;
    }

    getSearchContent(searchValue);
  }, [searchValue]);

  async function getSearchContent(search: string) {
    const parameters = {
      mediaCode: mediaCode || '',
      keyword: search,
      authorization: authorization || '',
    };

    try {
      return await getSearch(parameters).then((response) => {
        if (response.success) {
          setResults((response?.content) || []);
        } else {
          return [];
        }
      });
    } catch (error: any) {
      return {
        success: false,
        message: error?.message || 'Não foi possível realizar a busca!',
      };
    }
  }

  async function jumpTo(startTime: number) {
    if (hls && hls.media) {
      hls.media.currentTime = startTime;
      hls.media.play();
      onClose();
    }
  }

  const renderItem = (item: SearchResult, index: number) => {
    const text = (search).toString().length >= 2 ?
      (item.text).split(search).join(`<strong>${search}</strong>`) :
      (item.text);

    return (
      <li key={item.startTime} className="search__resultItem" tabIndex={100 + index} onClick={() => jumpTo(item.startTime)}>
        <p dangerouslySetInnerHTML={{ __html: text }} />
        <span>{ castTime(item.startTime) }</span>
      </li>
    );
  }

  useEffect(() => {
    if (!mediaCode) {
      return;
    }

    const rootElement = document.querySelector(`[data-code="${mediaCode}"]`) as HTMLDivElement;

    if (!rootElement) {
      return;
    }

    if (opened) {
      setSearch('');
      setResults([]);

      setTimeout(() => {
        const searchInput = rootElement.querySelector('.search__input') as HTMLInputElement;

        if (searchInput) {
          searchInput.focus();
        }
      }, 500);

      // rootElement.querySelector('.smartplayer__footer')?.classList.add('smartplayer__footer--dropdown');
    } else if (!hasAIOpened) {
      // rootElement.querySelector('.smartplayer__footer')?.classList.remove('smartplayer__footer--dropdown');
    }

  }, [opened, mediaCode, hasAIOpened]);

  // if (!opened) {
  //   return null;
  // }

  return (
    <Container className={opened ? 'search--opened' : undefined} primaryColor={primaryColor}>
      <div className="search__backdrop" onClick={onSearchClose}></div>
      <div className="search__panel">
        <div className="search__panelWrapper">
          <div className="search__inputWrapper">
            <input className="search__input" autoComplete="off" placeholder="Pesquise algo" onChange={onSearchChange} value={search} />
            <button className="search__closeButton" onClick={onSearchClose}>
              <svg className="search__closeIcon" aria-hidden="true" focusable="false" data-prefix="fasr" data-icon="xmark" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" data-fa-i2svg="">
                <path fill="currentColor" d="M345 137l17-17L328 86.1l-17 17-119 119L73 103l-17-17L22.1 120l17 17 119 119L39 375l-17 17L56 425.9l17-17 119-119L311 409l17 17L361.9 392l-17-17-119-119L345 137z"></path>
              </svg>
            </button>
          </div>
          <ul className="search__resultWrapper">
            {
              (results || []).length === 0 ? (
                <div>
                  Para pesquisar, digite alguma coisa.
                </div>
              ) : (
                results.map((item, index) => renderItem(item, index))
              )
            }
          </ul>
        </div>
      </div>
    </Container>
  );
};
